import { parseApiUtcTimestamp, resolveSessionTimeZone } from './api-utc-datetime.util';

/** Converte timestamps com fuso para o horario da sessao; valores locais mantem sua hora. */
export function normalizeCustomDateTimeForInput(raw: string | null | undefined): string | null {
  const value = (raw ?? '').trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,7})?)?([zZ]|[+-]\d{2}:\d{2})?$/.exec(value);
  if (!match) return null;
  const [, year, month, day, hour, minute, seconds, zone] = match;
  const second = seconds ?? '00';
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() !== Number(month) - 1
      || date.getUTCDate() !== Number(day) || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) {
    return null;
  }
  if (!zone) return `${year}-${month}-${day}T${hour}:${minute}:${second}`;

  const timestamp = parseApiUtcTimestamp(value);
  if (!timestamp) return null;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: resolveSessionTimeZone(), hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).formatToParts(timestamp);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find(p => p.type === type)!.value;
  return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}:${part('second')}`;
}

/** Formata DATETIME em pt-BR, convertendo timestamps UTC/offset para o fuso da sessao. */
export function formatCustomDateTimeForDisplay(raw: string | null | undefined): string {
  const value = (raw ?? '').trim();
  const local = normalizeCustomDateTimeForInput(value);
  if (!local) return value;
  const [date, time] = local.split('T');
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year} ${time.slice(0, 5)}`;
}

/**
 * Formata valor de campo personalizado TIME para exibição em pt-BR ("HH:mm").
 * Aceita HH:mm[:ss]. Retorna o valor original (trim) quando não bater.
 */
export function formatCustomTimeForDisplay(raw: string | null | undefined): string {
  const t = (raw ?? '').trim();
  if (!t) return '';
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(t);
  if (!match) return t;
  const h = match[1].padStart(2, '0');
  return `${h}:${match[2]}`;
}
